import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DirectoryPage from "../pages/directory/page";
import ForumsPage from "../pages/forums/page";
import GuidePage from "../pages/guide/page";
import GuideDetailPage from "../pages/guide-detail/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/directory",
    element: <DirectoryPage />,
  },
  {
    path: "/forums",
    element: <ForumsPage />,
  },
  {
    path: "/guide",
    element: <GuidePage />,
  },
  {
    path: "/guide/:slug",
    element: <GuideDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;